import React from "react";

const reviews = [
  {
    name: "tw&c",
    role: "Instagram Seller • App Store",
    quote: "I’ve been using this app for almost a year to watermark products on my IG account. So easy to use, and my photos stay as sharp as the original file with zero quality drop. Loved it!",
    stars: 5,
  },
  {
    name: "Kevin Wacknov",
    role: "Travel Creator • Google Play",
    quote: "I can batch watermark photos from trips or events in just a few taps, which saves a lot of time. The watermark template makes designing watermarked photos simple and fast.",
    stars: 5,
  },
  {
    name: "Tracey Morse",
    role: "Photographer • Google Play",
    quote: "Love this app for watermarking my photos. Super easy to use, and once you create your template, applying your watermark to single photos or several is effortless.",
    stars: 5,
  },
  {
    name: "Kayla M.",
    role: "Content Creator • App Store",
    quote: "Super easy to use and no registration required. Being able to watermark multiple photos all at once makes life so much easier!",
    stars: 5,
  },
  {
    name: "Dave (RealDigzz)",
    role: "iOS Developer & Photographer • App Store",
    quote: "I was looking for a watermark app that worked as described, and this is it. As an iOS developer and photographer, I highly approve of this app from both perspectives.",
    stars: 5,
  },
  {
    name: "Macias Dav",
    role: "Business Owner • App Store",
    quote: "I’ve been using the software from practically the first time it was released and I’ve been incredibly impressed with its performance. I use it for my business and don't know what I could do without it.",
    stars: 5,
  },
  {
    name: "Bohamom",
    role: "Medical Spa Owner • App Store",
    quote: "I use this app everyday! I put our company logo and texts onto before and after photos for social media. Pleasantly surprised with how easy and intuitive it is to use.",
    stars: 5,
  },
  {
    name: "Purvo Tone",
    role: "Visual Artist • App Store",
    quote: "Amazingly simple to add watermarks. Beautiful script font selection and custom colors that fit seamlessly with each image. Highly recommend to anyone looking for a top-notch tool!",
    stars: 5,
  },
  {
    name: "Mike Kelly",
    role: "Digital Brand Creator • Google Play",
    quote: "Fabulous app, helps protect our Instagram content. Easy to use with single or multiple images. We created our digital signature with a transparent background — totally recommend it!",
    stars: 5,
  },
  {
    name: "Nikki (MsNykee22)",
    role: "Artisan & Crafter • App Store",
    quote: "I’m a crafter and wanted to watermark my photos before posting on social media. This works perfectly! I can match font colors to my designs with zero loss in photo quality.",
    stars: 5,
  },
  {
    name: "Doll97",
    role: "Independent Artist • App Store",
    quote: "Essential app to protect my creations so no one steals them. Straightforward, easy to use, and lets you share directly to any platform without extra hassle.",
    stars: 5,
  },
  {
    name: "Kimberly Til",
    role: "Verified Creator • App Store",
    quote: "Thank you to the folks at eZy Watermark for making watermarking so accessible, fast, and easy to protect our work!",
    stars: 5,
  },
];

const initials = (name: string) => {
  const parts = name.replace(/[()]/g, "").trim().split(/\s+/);
  if (parts.length >= 2) {
    return (parts[0][0] + parts[1][0]).toUpperCase();
  }
  return name.slice(0, 2).toUpperCase();
};

const Stars: React.FC<{ n: number; muted?: boolean }> = ({ n, muted = false }) => (
  <div className={`lr-testimonials__stars ${muted ? "lr-testimonials__stars--muted" : ""}`}>
    {Array.from({ length: n }).map((_, i) => (
      <svg key={i} viewBox="0 0 20 20">
        <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" />
      </svg>
    ))}
  </div>
);

const TestimonialsShowcase: React.FC = () => {
  return (
    <section id="reviews" className="lr-section">
      <div className="lr-section__inner lr-testimonials">
        <div className="lr-testimonials__head">
          <span className="lr-testimonials__eyebrow">Wall of Love</span>
          <h2 className="lr-testimonials__heading">
            Trusted by millions of <span>creators</span>
          </h2>
        </div>

        <div className="lr-testimonials__grid">
          {/* Column 1 */}
          <div className="lr-testimonials__col">
            <div className="lr-testimonials__card">
              <Stars n={reviews[0].stars} />
              <p className="lr-testimonials__quote">&quot;{reviews[0].quote}&quot;</p>
              <div className="lr-testimonials__person">
                <div className="lr-testimonials__avatar">{initials(reviews[0].name)}</div>
                <div>
                  <div className="lr-testimonials__name">{reviews[0].name}</div>
                  <div className="lr-testimonials__role">{reviews[0].role}</div>
                </div>
              </div>
            </div>

            <div className="lr-testimonials__card">
              <p className="lr-testimonials__quote">&quot;{reviews[1].quote}&quot;</p>
              <div className="lr-testimonials__person">
                <div className="lr-testimonials__avatar lr-testimonials__avatar--muted">
                  {initials(reviews[1].name)}
                </div>
                <div>
                  <div className="lr-testimonials__name">{reviews[1].name}</div>
                  <div className="lr-testimonials__role">{reviews[1].role}</div>
                </div>
              </div>
            </div>

            <div className="lr-testimonials__card">
              <p className="lr-testimonials__quote">&quot;{reviews[2].quote}&quot;</p>
              <div className="lr-testimonials__person">
                <div className="lr-testimonials__avatar">{initials(reviews[2].name)}</div>
                <div>
                  <div className="lr-testimonials__name">{reviews[2].name}</div>
                  <div className="lr-testimonials__role">{reviews[2].role}</div>
                </div>
              </div>
            </div>

            <div className="lr-testimonials__card">
              <p className="lr-testimonials__quote">&quot;{reviews[3].quote}&quot;</p>
              <div className="lr-testimonials__person">
                <div className="lr-testimonials__avatar lr-testimonials__avatar--muted">
                  {initials(reviews[3].name)}
                </div>
                <div>
                  <div className="lr-testimonials__name">{reviews[3].name}</div>
                  <div className="lr-testimonials__role">{reviews[3].role}</div>
                </div>
              </div>
            </div>
          </div>

          {/* Column 2 */}
          <div className="lr-testimonials__col lr-testimonials__col--mid">
            <div className="lr-testimonials__card">
              <p className="lr-testimonials__quote">&quot;{reviews[4].quote}&quot;</p>
              <div className="lr-testimonials__person">
                <div className="lr-testimonials__avatar">{initials(reviews[4].name)}</div>
                <div>
                  <div className="lr-testimonials__name">{reviews[4].name}</div>
                  <div className="lr-testimonials__role">{reviews[4].role}</div>
                </div>
              </div>
            </div>

            <div className="lr-testimonials__card lr-testimonials__card--featured">
              <p className="lr-testimonials__quote">&quot;{reviews[5].quote}&quot;</p>
              <div className="lr-testimonials__person">
                <div className="lr-testimonials__avatar lr-testimonials__avatar--ring">
                  {initials(reviews[5].name)}
                </div>
                <div>
                  <div className="lr-testimonials__name">{reviews[5].name}</div>
                  <div className="lr-testimonials__role">{reviews[5].role}</div>
                </div>
              </div>
            </div>

            <div className="lr-testimonials__card">
              <p className="lr-testimonials__quote">&quot;{reviews[6].quote}&quot;</p>
              <div className="lr-testimonials__person">
                <div className="lr-testimonials__avatar lr-testimonials__avatar--muted">
                  {initials(reviews[6].name)}
                </div>
                <div>
                  <div className="lr-testimonials__name">{reviews[6].name}</div>
                  <div className="lr-testimonials__role">{reviews[6].role}</div>
                </div>
              </div>
            </div>

            <div className="lr-testimonials__card">
              <Stars n={reviews[7].stars} />
              <p className="lr-testimonials__quote">&quot;{reviews[7].quote}&quot;</p>
              <div className="lr-testimonials__person">
                <div className="lr-testimonials__avatar">{initials(reviews[7].name)}</div>
                <div>
                  <div className="lr-testimonials__name">{reviews[7].name}</div>
                  <div className="lr-testimonials__role">{reviews[7].role}</div>
                </div>
              </div>
            </div>
          </div>

          {/* Column 3 */}
          <div className="lr-testimonials__col lr-testimonials__col--right">
            <div className="lr-testimonials__card">
              <p className="lr-testimonials__quote">&quot;{reviews[8].quote}&quot;</p>
              <div className="lr-testimonials__person">
                <div className="lr-testimonials__avatar lr-testimonials__avatar--muted">
                  {initials(reviews[8].name)}
                </div>
                <div>
                  <div className="lr-testimonials__name">{reviews[8].name}</div>
                  <div className="lr-testimonials__role">{reviews[8].role}</div>
                </div>
              </div>
            </div>

            <div className="lr-testimonials__card">
              <p className="lr-testimonials__quote">&quot;{reviews[9].quote}&quot;</p>
              <div className="lr-testimonials__person">
                <div className="lr-testimonials__avatar">{initials(reviews[9].name)}</div>
                <div>
                  <div className="lr-testimonials__name">{reviews[9].name}</div>
                  <div className="lr-testimonials__role">{reviews[9].role}</div>
                </div>
              </div>
            </div>

            <div className="lr-testimonials__card">
              <p className="lr-testimonials__quote">&quot;{reviews[10].quote}&quot;</p>
              <div className="lr-testimonials__person">
                <div className="lr-testimonials__avatar lr-testimonials__avatar--muted">
                  {initials(reviews[10].name)}
                </div>
                <div>
                  <div className="lr-testimonials__name">{reviews[10].name}</div>
                  <div className="lr-testimonials__role">{reviews[10].role}</div>
                </div>
              </div>
            </div>

            <div className="lr-testimonials__card">
              <Stars n={reviews[11].stars} muted />
              <p className="lr-testimonials__quote">&quot;{reviews[11].quote}&quot;</p>
              <div className="lr-testimonials__person">
                <div className="lr-testimonials__avatar lr-testimonials__avatar--muted">
                  {initials(reviews[11].name)}
                </div>
                <div>
                  <div className="lr-testimonials__name">{reviews[11].name}</div>
                  <div className="lr-testimonials__role">{reviews[11].role}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default TestimonialsShowcase;
